import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataService } from '../data.service';

@Injectable({
    providedIn: 'root'
  })

  export class RatesQueryDetailsReportService extends DataService {
    private baseURI = this.apiUri + '/ratesquerydetails';

    constructor(http: HttpClient) {
      super(http);
    }

    getRatesQueryDetails(businessType: any): Observable<any[]>{
        this.setUri(this.baseURI + '/getallhhgratesqueryDetails/' + businessType + '/businesstype' );
    return this.get().pipe(catchError(this.handleError));
    }

    getRatesQueryDetailsByDate(businessType:any, startDate:any, endDate:any): Observable<any[]>{
      this.setUri(this.baseURI + '/dates/' + businessType + '/businesstype/' + startDate + '/startdate/' + endDate + '/enddate');
      return this.get().pipe(catchError(this.handleError));
    }
  
}